import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import SEO from "@/components/SEO";
import { Check } from "lucide-react";

const BENEFITS = [
  "Üst düzey bayi marjları ve kademeli iskonto",
  "İlk siparişte ücretsiz teşhir standı",
  "Eğitim ve atölye desteği",
  "Dijital pazarlama materyalleri (fotoğraf, broşür)",
  "Bölgesel münhasırlık seçeneği",
  "7/24 destek hattı",
];

export default function DealerApply() {
  const [form, setForm] = useState({ name: "", company: "", email: "", phone: "", city: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/dealers/apply", form);
      setDone(true);
      toast.success("Başvurunuz alındı. En kısa sürede sizinle iletişime geçeceğiz.");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <>
      <SEO title="Bayi Başvurusu" description="Wünberg bayilik başvurusu. Özel marjlar, eğitim ve pazarlama desteği ile premium akrilik kategorisinde büyüyün." />
      <section className="pt-32 pb-12 border-b border-white/10">
        <div className="wb-container">
          <div className="wb-overline">Bayilik</div>
          <h1 className="wb-h1 mt-3">Bayi <span className="italic text-[#d4af37]">Ol</span>.</h1>
          <p className="wb-body mt-5 max-w-2xl">
            Türkiye'nin önde gelen sanatçı ve hobi mağazaları Wünberg'i tercih ediyor.
            Aramıza katılın.
          </p>
        </div>
      </section>

      <section className="wb-section">
        <div className="wb-container grid grid-cols-1 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2 space-y-6">
            <div className="wb-overline">Bayi Avantajları</div>
            <ul className="space-y-3 mt-4">
              {BENEFITS.map((b) => (
                <li key={b} className="flex items-start gap-3 text-sm">
                  <Check size={16} className="text-[#d4af37] mt-1 flex-shrink-0" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>
            <div className="wb-card p-6 mt-8">
              <div className="font-serif text-lg">Süreç</div>
              <ol className="text-sm text-[#a0aabf] mt-3 space-y-2 list-decimal pl-5">
                <li>Başvuru formunu doldurun.</li>
                <li>Ekibimiz 2-3 iş günü içinde değerlendirir.</li>
                <li>Telefon görüşmesi sonrası bayilik aktif edilir.</li>
                <li>Giriş bilgileriniz e-posta ile iletilir.</li>
              </ol>
            </div>
          </div>

          <div className="lg:col-span-3">
            {done ? (
              <div className="wb-card p-12 text-center">
                <div className="w-16 h-16 mx-auto bg-[#d4af37]/10 border border-[#d4af37] flex items-center justify-center">
                  <Check className="text-[#d4af37]" size={28} />
                </div>
                <h2 className="wb-h3 mt-6">Başvurunuz alındı</h2>
                <p className="text-sm text-[#a0aabf] mt-3 max-w-md mx-auto">
                  Ekibimiz başvurunuzu değerlendirip 2-3 iş günü içinde sizinle iletişime geçecektir.
                </p>
              </div>
            ) : (
              <form onSubmit={submit} className="wb-card p-8 space-y-4" data-testid="dealer-apply-form">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <input className="wb-input" placeholder="Adınız Soyadınız" required value={form.name} onChange={set("name")} data-testid="apply-input-name" />
                  <input className="wb-input" placeholder="Firma / Mağaza" required value={form.company} onChange={set("company")} data-testid="apply-input-company" />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <input className="wb-input" type="email" placeholder="E-posta" required value={form.email} onChange={set("email")} data-testid="apply-input-email" />
                  <input className="wb-input" placeholder="Telefon" required value={form.phone} onChange={set("phone")} data-testid="apply-input-phone" />
                </div>
                <input className="wb-input" placeholder="Şehir" required value={form.city} onChange={set("city")} data-testid="apply-input-city" />
                <textarea className="wb-input min-h-[140px] resize-none" placeholder="Mağaza/firma hakkında kısa bilgi (opsiyonel)" value={form.message} onChange={set("message")} data-testid="apply-input-message" />
                <button type="submit" disabled={loading} className="wb-btn-primary w-full sm:w-auto" data-testid="apply-submit">
                  {loading ? "Gönderiliyor..." : "Başvuruyu Gönder"}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
